module.exports = __webpack_public_path__ + "img/db_lorry.5ad92cca.jpg";